var app = angular.module("leonardo");

var DeleteApprovalStepDialog = function($scope, FormErrorsService) {
  $scope.object = $scope.ngDialogData.object;
  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.confirm($scope.object);
  };
};

app.controller('DeleteApprovalStepDialog', ['$scope', 'FormErrorsService', DeleteApprovalStepDialog]);
